/* ════════════ TRI-COLOR PIXEL RAIN ════════════
   The stack page's atmosphere: sparse digital rain falling in the
   three protocol colors (nostr purple, bitcoin gold, monero
   vermilion) with the occasional phosphor-green column. */

import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function rain(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#rain")!;
  const ctx = c.getContext("2d")!;

  const SIZE = 3; // pixel block size
  const SPACING = 22; // column spacing
  // green is in the palette once, so roughly 1 column in 7 is phosphor
  const palette = ["#a06bff", "#a06bff", "#f7931a", "#f7931a", "#ff4d2e", "#ff4d2e", "#00ffa3"];

  type Col = { x: number; y: number; v: number; trail: number; wait: number; col: string };
  let cols: Col[] = [];

  const reset = (col: Col, first: boolean) => {
    col.y = first ? Math.random() * c.height : -Math.random() * c.height * 0.5;
    col.v = 0.4 + Math.random() * 1.1;
    col.trail = 6 + (Math.random() * 10) | 0;
    col.wait = first ? 0 : 60 + Math.random() * 240;
    col.col = palette[(Math.random() * palette.length) | 0]!;
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    cols = Array.from({ length: Math.ceil(c.width / SPACING) }, (_, i) => {
      const col: Col = { x: i * SPACING + 6, y: 0, v: 1, trail: 8, wait: 0, col: palette[0]! };
      reset(col, true);
      return col;
    });
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const col of cols) {
      if (col.wait > 0) continue;
      ctx.fillStyle = col.col;
      for (let i = 0; i < col.trail; i++) {
        const y = col.y - i * SIZE * 2;
        if (y < -SIZE || y > c.height + SIZE) continue;
        ctx.globalAlpha = i === 0 ? 0.9 : (1 - i / col.trail) * 0.45;
        ctx.fillRect(col.x, y | 0, SIZE, SIZE);
      }
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const col of cols) {
      if (col.wait > 0) {
        col.wait--;
        continue;
      }
      col.y += col.v;
      if (col.y - col.trail * SIZE * 2 > c.height) reset(col, false);
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage(rain);
